import Vuex, { Store } from "vuex";
import { createLocalVue, shallowMount } from "@vue/test-utils";
import StepNavigator from "@/components/core/StepNavigator";

const localVue = createLocalVue();
localVue.use(Vuex);

describe("StepNavigator component", () => {
  let wrapper;
  let store;
  let getters;

  beforeEach(() => {
    getters = {
      getRoute: function () {
        return () => ({
          route: {}
        });
      }
    };

    store = new Store({ getters });

    wrapper = shallowMount(StepNavigator, {
      store,
      localVue
    });
  });

  it("Renders del component StepNavigator", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
